import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c005ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto pb-24" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "tabs mb-2" }
const _hoisted_4 = { class: "tab mb-2 pb-2 rounded-3xl py-3" }
const _hoisted_5 = { class: "relative general-container pb-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "primary w-full absolute z-10 cursor-pointer opacity-0 h-16 left-0 top-1 bg-gray-400",
  id: "chck1",
  type: "checkbox"
}, null, -1))
const _hoisted_7 = {
  class: "flex justify-between items-center cursor-pointer select-none tab-label bg-gray-400 rounded-lg mb-2",
  for: "chck1"
}
const _hoisted_8 = { class: "text-white font-bold text-left text-base md:text-3xl lg:text-2xl" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rounded-full w-7 h-7 flex items-center justify-center test" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    "data-reactid": "266",
    fill: "none",
    height: "24",
    stroke: "#fff",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    viewbox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "6 9 12 15 18 9" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("header", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t(row.text)), 1),
                _hoisted_9
              ]),
              _renderSlot(_ctx.$slots, row.id, {}, undefined, true)
            ])
          ]))
        }), 256))
      ])
    ])
  ]))
}